var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".55vw",
    height: "0.6vw",
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11L8.27778 8.77778M9.38889 5.44444C9.38889 6.62318 8.92064 7.75365 8.08714 8.58714C7.25365 9.42064 6.12318 9.88889 4.94444 9.88889C3.7657 9.88889 2.63524 9.42064 1.80175 8.58714C0.968253 7.75365 0.5 6.62318 0.5 5.44444C0.5 4.2657 0.968253 3.13524 1.80175 2.30175C2.63524 1.46825 3.7657 1 4.94444 1C6.12318 1 7.25365 1.46825 8.08714 2.30175C8.92064 3.13524 9.38889 4.2657 9.38889 5.44444Z",
    stroke: "#E77B7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedSearch);
export default __webpack_public_path__ + "static/media/redSearch.e398420c6dbaa55f41d65b51c5fe6b53.svg";
export { ForwardRef as ReactComponent };